(function(){
  if(window.__odraHomeInit) return; window.__odraHomeInit = true;
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function boot(){
    document.querySelectorAll('[data-odra-home]').forEach(initRoot);
  }
  function initRoot(root){
    if(root.__init) return; root.__init = true;
    // announcement rotator
    var msgEl = root.querySelector('[data-announce-msg]');
    var lines = (root.getAttribute('data-announce-lines')||'').split('||').filter(Boolean);
    if(msgEl && lines.length>1){
      var idx=0;
      setInterval(function(){
        idx=(idx+1)%lines.length;
        msgEl.style.opacity=0;
        setTimeout(function(){ msgEl.innerHTML = lines[idx].replace(/(₹[0-9,]+)/,'<span class="price">$1</span>'); msgEl.style.opacity=.92; },380);
      },4000);
    }
    // reveal on scroll
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} }); },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
      root.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
    } else { root.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }
    // delegated clicks
    root.addEventListener('click', function(e){
      var close=e.target.closest('[data-announce-close]');
      if(close){ var a=close.closest('[data-announce]'); if(a) a.remove(); return; }
      var sc=e.target.closest('[data-scroll]');
      if(sc){ var t=document.querySelector(sc.getAttribute('data-scroll')); if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth'}); } return; }
      var faq=e.target.closest('[data-faq]');
      if(faq){ var item=faq.closest('[data-faq-item]'); var open=item.classList.toggle('open'); var body=item.querySelector('[data-faq-body]'); if(body) body.style.maxHeight=open?body.scrollHeight+'px':'0px'; return; }
      var add=e.target.closest('[data-add-id]');
      if(add){ e.preventDefault(); addToCart(add.getAttribute('data-add-id')); return; }
    });
    // before/after slider
    root.querySelectorAll('[data-slider]').forEach(function(s){
      var handle=s.querySelector('[data-slider-handle]'); var top=s.querySelector('[data-slider-top]');
      if(!handle||!top) return;
      function set(x){ var r=s.getBoundingClientRect(); var p=Math.max(0,Math.min(1,(x-r.left)/r.width)); top.style.clipPath='inset(0 '+((1-p)*100)+'% 0 0)'; handle.style.left=(p*100)+'%'; }
      var drag=false;
      function move(e){ set(e.touches?e.touches[0].clientX:e.clientX); }
      s.addEventListener('mousedown',function(e){drag=true;move(e);e.preventDefault();});
      s.addEventListener('touchstart',function(e){drag=true;move(e);},{passive:true});
      window.addEventListener('mousemove',function(e){if(drag)move(e);});
      window.addEventListener('touchmove',function(e){if(drag)move(e);},{passive:true});
      window.addEventListener('mouseup',function(){drag=false;}); window.addEventListener('touchend',function(){drag=false;});
      set(s.getBoundingClientRect().width*0.5);
    });
  }
  function addToCart(id){
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){ window.location.href='/cart'; })
      .catch(function(){ window.location.href='/cart'; });
  }
  ready(boot);
  document.addEventListener('shopify:section:load', boot);
})();
